/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Pearl_Mole_FadeInputs */

const en_soft_pearl_mole_fade = /** @type {(inputs: Soft_Pearl_Mole_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved changes`)
};

const de_soft_pearl_mole_fade = /** @type {(inputs: Soft_Pearl_Mole_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen gespeichert`)
};

/**
* | output |
* | --- |
* | "Saved changes" |
*
* @param {Soft_Pearl_Mole_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_pearl_mole_fade = /** @type {((inputs?: Soft_Pearl_Mole_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Pearl_Mole_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_pearl_mole_fade(inputs)
	return de_soft_pearl_mole_fade(inputs)
});